import React, {useState, useEffect} from 'react';
import {LoadingIndicator} from "./loading-indicator";
import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class LoaderProps extends BaseProps {
  Component: React.Component;
  className: String;
  componentProps: BaseProps;
  trigger: Boolean;
  when: Boolean;
}

export const Loader = ({trigger, when, children, Component, componentProps, className}: LoaderProps) => {
  const [lastTrigger, setLastTrigger] = useState(trigger);
  const [loading, setLoading] = useState(when);

  useEffect(() => {
    const hasTriggerChanged = (trigger?.toString()) !== lastTrigger;

    if (hasTriggerChanged) {
      setLastTrigger((trigger?.toString()));
      setLoading(when);
    } else if (when) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [trigger, when]);

  const LoaderComponent = Component ? <Component {...componentProps} /> :
    <div className={className}><LoadingIndicator/></div>;

  return loading ? LoaderComponent : children;
};

